import { useMutation } from "@tanstack/react-query"

import { useStableFunction } from "@repo/ui/hooks/use-stable-function"
import { useSupabase } from "./use-supabase"

type ResetPasswordCredentials = {
  email: string
  redirectTo?: string
  captchaToken?: string
}

const mutationKey = ["auth", "reset-password"]

export type UseResetPasswordProps = {
  onSuccess?: VoidFunction
  onError?: (error: Error) => void
}

export function useResetPassword({
  onSuccess,
  onError,
}: UseResetPasswordProps = {}) {
  const supabase = useSupabase()

  const mutationFn = useStableFunction(
    async ({ email, ...options }: ResetPasswordCredentials) => {
      const { data, error } = await supabase.auth.resetPasswordForEmail(
        email,
        options,
      )

      if (error) {
        throw error
      }

      return data
    },
  )

  return useMutation({
    mutationKey,
    mutationFn,
    onSuccess,
    onError,
  })
}
